import { useId } from 'react';
import Select from 'react-select';

export default function SearchableSelect({ label, options, value, onChange, placeholder, emptyMessage, description, labelDescription, filterOption, overlay = true, disabled = false }) {
 const id = useId();
 const selected = options.find(option => option.value === value) || (value ? { value, label: value } : null);
 return <div className="field scheduler-search-select">
  <label className="label" htmlFor={id}>{label}</label>
  {labelDescription && <p id={`${id}-hint`} className="caption scheduler-select-hint">{labelDescription}</p>}
  <Select inputId={id} instanceId={id} options={options} value={selected}
   onChange={option => onChange(option.value)} isSearchable isDisabled={disabled} aria-describedby={[labelDescription && `${id}-hint`, description && `${id}-description`].filter(Boolean).join(' ') || undefined}
   placeholder={placeholder} filterOption={filterOption}
   noOptionsMessage={() => emptyMessage} maxMenuHeight={180}
   classNamePrefix="scheduler-select" menuPlacement="bottom" menuPosition={overlay ? 'fixed' : 'absolute'}
   styles={{
    control: (base, state) => ({ ...base, minHeight: 44, borderRadius: 8, borderColor: state.isFocused ? '#3896f4' : '#cbd5e1', boxShadow: state.isFocused ? '0 0 0 2px #3896f4' : 'none' }),
    input: base => ({ ...base, color: '#18243a' }),
    singleValue: base => ({ ...base, color: '#18243a' }),
    menu: base => overlay ? { ...base, zIndex: 5 } : { ...base, position: 'relative', top: 'auto', bottom: 'auto', zIndex: 5 },
    menuPortal: base => ({ ...base, zIndex: 5 }),
    option: (base, state) => ({ ...base, overflowWrap: 'anywhere', backgroundColor: state.isSelected ? '#e3222a' : state.isFocused ? '#f1f5f9' : '#fff', color: state.isSelected ? '#fff' : '#18243a' }),
   }} />
  {description && <p id={`${id}-description`} className="caption">{description}</p>}
 </div>;
}
